// History action contains text with a current type and a new type (twice) in uppercase format
// If the current type and the new type are the same, result count will be equal to 3
// Example: "Lead Update: The lead fulfils TRADE criteria due to update in Central Bike Database. Lead type criteria has successfully changed FROM RETAIL TO TRADE.

export const checkLeadTypeUpdate = (action) => {
    const results = {};

    ['RETAIL', 'TRADE', 'SCRAP'].forEach(type => {
        if (action?.includes(type)) {
            results[type] = action.split(type).length - 1;
        }
    });

    return Object.values(results).every((count) => count !== 3);
};

export const isBikeManagementUpdate = (action) => action.includes('update in Central Bike Database');



// WEBPACK FOOTER //
// ./src/modules/Leads/utils/leadType.js